const Footer = () => {
  return (
    <footer
      style={{
        textAlign: "center",
        color: "#4B5563",
        fontSize: "0.9375rem",
        marginTop: "2rem",
      }}
    >
      Need help?{" "}
      <a
        href="mailto:support@unifize.com"
        style={{
          color: "#0078d4",
          textDecoration: "none",
          fontWeight: 500,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.textDecoration = "underline";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.textDecoration = "none";
        }}
      >
        Contact Unifize Support
      </a>
    </footer>
  );
};

export default Footer;
